import store from '../store'

export default class AuthHelper {
  static checkErrorExpiredToken (error) {
    if (error.status === 401) {
      store.dispatch('signout')
    }
  }
}
